export { ReviewPage as default } from 'src/components/pages/Ir/Financial/Review'
